import { canViewHref } from "@/lib/acl";
import type { CurrentUser } from "@/lib/auth";
import { userIsBuero } from "@/lib/auth";
import {
  userCanCreateTimesheetsFromOverview,
  userCanViewBueroProjectOverviewSections,
} from "@/projectOverview/permissions";
import type { NoteRefType } from "@/projectOverview/notes/types";

export async function canOpenNoteReference(
  refType: NoteRefType | string,
  user: CurrentUser | null,
  groups: string[],
): Promise<boolean> {
  switch (refType) {
    case "auftrag":
      return (
        (await canViewHref("/auftraege.html", groups)) ||
        (await canViewHref("/projekte", groups))
      );
    case "order":
      if (!userCanViewBueroProjectOverviewSections(user)) return false;
      return canViewHref("/bestellungen.html", groups);
    case "timesheet":
      if (userIsBuero(user)) return true;
      if (await canViewHref("/stundennachweise", groups)) return true;
      return userCanCreateTimesheetsFromOverview(user, groups);
    case "employee":
      return true;
    case "material_anforderung":
      return canViewHref("/materialanforderungen.html", groups);
    case "geschaeftsdokument":
      return canViewHref("/dokumente.html", groups);
    default:
      return false;
  }
}

export function noteReferencePermissionMessage(refType: NoteRefType | string): string {
  switch (refType) {
    case "auftrag":
      return "Keine Berechtigung für die Projektübersicht.";
    case "order":
      return "Keine Berechtigung für Bestellungen.";
    case "timesheet":
      return "Keine Berechtigung für Stundennachweise.";
    case "material_anforderung":
      return "Keine Berechtigung für Materialanforderungen.";
    case "geschaeftsdokument":
      return "Keine Berechtigung für Geschäftsdokumente.";
    default:
      return "Keine Berechtigung für diese Referenz.";
  }
}
